/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- COMMENTING DIVISION : STYLES --------------- ++++++++++ */
export default theme => ({
  triviapollsconfigpage: {
    '& .content': { minHeight: 'auto' },
    '& .incontentmessage': { padding: `${pxToEm(16)} !important` },
    '& iframe': {
      border: 0,
      height: '100%',
      width: '100%'
    }
  } 
});
